export const GraphAggregated = ({
  fillColor,
  width = '10rem',
}: {
  fillColor: string;
  width?: string;
}) => (
  <svg width={width} viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
    {/* Axes */}
    <line x1='0' y1='0' x2='0' y2='20' stroke={fillColor} strokeWidth={1} />
    <line x1='0' y1='20' x2='20' y2='20' stroke={fillColor} strokeWidth={1} />
    {/* Chart */}
    <polygon
      points='2,14 4,12 6,9 8,8 10,6.5 12,8 14,9 16,11.5 18,11 18,17 16,16 14,15 12,12.5 10,12.5 8,13 6,14.5 4,16 2,17'
      fill={fillColor}
      opacity='0.3'
    />
    <polyline
      points='2,16 4,14.5 6,12.2 8,11 10,9.5 12,10.5 14,11.8 16,14 18,13.5'
      fill='none'
      stroke={fillColor}
      strokeWidth='0.5'
    />
  </svg>
);
